<script lang='ts'>
  import { onMount } from "svelte";
    import { xssDeviationToCategory, type XSSDetails, formatXSSDetails, type XSSDeviationDetails } from "../../Util/utils";
    import XssDeviationIcon from "../XssDeviationIcon.svelte";

    export let title: string
    export let xssDetails: XSSDetails
    export let targetXssDetails: XSSDetails | null = null
    export let showRowNames: boolean = true

    let xssDetailsStrings: XSSDetails<string> | null = null
    let xssDetailsCategories: XSSDetails<XSSDeviationDetails> | null = null

    onMount(() => {
        xssDetailsStrings = formatXSSDetails(xssDetails)
        if (targetXssDetails) {
            xssDetailsCategories = xssDeviationToCategory(xssDetails, targetXssDetails)
        }
    })
</script>

{#if xssDetailsStrings} 
    <div class="font-bold">
        <h5 class="w-full text-start m-0 font-bold">{title}</h5>
        <div class="xsstable">
            {#if showRowNames}
                <div>
                    <p>Peak</p>
                    <p>High</p>
                    <p>Low</p>
                    <p>Total</p>
                </div>
            {/if}
            <div>
                <p class="text-right text-[var(--color-xpss)]">{xssDetailsStrings.xpss}</p>
                <p class="text-right text-[var(--color-xhss)]">{xssDetailsStrings.xhss}</p>
                <p class="text-right text-[var(--color-xlss)]">{xssDetailsStrings.xlss}</p>
                <p class="text-right ">{xssDetailsStrings.xss}</p>
            </div>
            {#if targetXssDetails}
                <div class="ml-[5px]">
                    <span class="block text-right">
                        <XssDeviationIcon category={xssDetailsCategories.xpss.suitability} />
                    </span>
                    <span class="block text-right">
                        <XssDeviationIcon category={xssDetailsCategories.xhss.suitability} />
                    </span>
                    <span class="block text-right">
                        <XssDeviationIcon category={xssDetailsCategories.xlss.suitability} />
                    </span>
                    <span class="block text-right">
                        <XssDeviationIcon category={xssDetailsCategories.xss.suitability} />
                    </span>
                </div>
            {/if}
        </div>
    </div>
{/if}

<style lang="scss">
    .xsstable {
        display: grid;
        grid-template-columns: 1fr 1fr auto;
    }
    p {
        margin: 0;
    }
</style>